// The ad platform's conversion event, fired when a lead is actually created.
//
// The pixel's setup script in index.html defines oaiq and queues calls until
// the SDK loads, so this is safe to call at any point. It is still guarded:
// an ad blocker can remove oaiq entirely, and a visitor leaving their details
// must not be broken by a blocked tracker.
//
// The backend sends the same conversion server-side with the lead's id, which
// is the half that survives ad blockers.
export function trackLeadCreated() {
  try {
    if (typeof window.oaiq !== "function") return;
    window.oaiq("measure", "lead_created", { type: "customer_action" });
  } catch {
    /* measurement must never break a submission */
  }
}
